import React from "react";
import InProgressModal from "../Components/InProgressModal";
import EmailIcon from "../Assets/emailIcon.svg";
import CheckIcon from "../Assets/checkMarkIcon.svg";
import Logo from "../Assets/logo.png";

export default function InProgressPage() {
  return (
    <div>
      <div className="flex items-center justify-center flex-col gap-6 h-[100vh]">
        <img className="w-[7.5rem] h-[2.25rem]" src={Logo} />
        <InProgressModal
          img={EmailIcon}
          heading="Check your email"
          text="To confirm your account, please check your email. We've sent you a"
          spantext="verification link."
        />
      </div>
    </div>
  );
}
